/// <amd-module name="Reporting/VelocityReport/VelocityReportPage" />
import * as React from "react";
import { getReportPageState, ReportState } from "Reporting/BoardsCommon/ReportPageState";
import { VelocityReport } from "Reporting/VelocityReport/VelocityReport";
import { IVssComponentProperties, VssComponent } from "VSS/Platform/Layout";

/** New Platform page for standalone testing of Velocity Report. Has no hardening for input validation */
export class VelocityReportPage extends VssComponent<IVssComponentProperties, ReportState> {
    public async componentDidMount(): Promise<void> {
        this.setState(await getReportPageState(this.context.pageContext));
    }

    public render(): JSX.Element | null {
        if (this.state == null) {
            return null;
        }
        return (
            <VelocityReport
                categoryReferenceName={this.state.categoryReferenceName}
                categoryName={this.state.categoryName}
                teamId={this.state.teamId}
                teamName={this.state.teamName}
                projectId={this.state.projectId}
            />
        );
    }
}
VssComponent.register("VelocityReportPage", VelocityReportPage);
